import * as React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import type { TxKeyPath } from '@/core';
import { Text } from '@/ui';

import { Checkbox } from '../checkbox';
import { Radio } from '../radio';

interface CheckItemProps {
  type?: 'checkbox' | 'radio';
  tx?: TxKeyPath;
  text?: string;
  onPress: () => void;
  active?: boolean;
  disabled?: boolean;
  style?: any;
  textStyle?: any;
  caption?: string;
}

export const CheckItem = ({
  type,
  tx,
  text,
  onPress,
  active = false,
  disabled = false,
  style,
  textStyle,
  caption,
}: CheckItemProps) => {
  const { styles, theme } = useStyles(stylesheet);

  const renderType = React.useMemo(() => {
    if (type === 'checkbox') {
      return <Checkbox onPress={onPress} active={active} disabled={disabled} />;
    }

    return <Radio onPress={onPress} active={active} disabled={disabled} />;
  }, [type, onPress, active, disabled]);

  return (
    <View hitSlop={8} style={[styles.container, style]}>
      <View style={{ flexDirection: 'row', gap: 8 }}>
        {renderType}

        <View style={{ flexBasis: 0, flexGrow: 1 }}>
          {tx ? (
            <Text
              type="bodyRegular"
              tx={tx}
              style={[
                disabled && {
                  color: theme.colors.button.primary.disabled.text,
                },
                textStyle,
              ]}
            />
          ) : (
            <Text
              type="bodyRegular"
              style={[
                disabled && {
                  color: theme.colors.button.primary.disabled.text,
                },
                textStyle,
              ]}
            >
              {text}
            </Text>
          )}

          {caption ? (
            <Text
              type="caption1"
              style={[
                { color: theme.colors.text.secondary },
                disabled && {
                  color: theme.colors.button.primary.disabled.text,
                },
              ]}
            >
              {caption}
            </Text>
          ) : null}
        </View>
      </View>
    </View>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexDirection: 'column',
    gap: 16,
  },
}));
